import React from 'react';
import Providers from 'components/Providers';
import Userback from '@userback/widget';

Userback('37568|76160|v0IzZWe1Wp6WdUZsgSwl1T41O');

export const wrapRootElement = ({ element }) => {
  return <Providers>{element}</Providers>;
};
